import * as React from 'react';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import axiosServices from 'utils/axios';
import Alert from '@mui/material/Alert';
import useConfig from 'hooks/useConfig';
import useAuth from 'hooks/useAuth';
import { InputLabel, Link, useMediaQuery, useTheme } from '@mui/material';
import { FormattedMessage } from 'react-intl';

const KeyFormDialog = (props: { open: boolean; handleClose: () => void }) => {
    const theme = useTheme();
    const { open, handleClose } = props;
    const { locale } = useConfig();
    const { updateProfile } = useAuth();
    const [key, setKey] = React.useState('');
    const matchDownMd = useMediaQuery(theme.breakpoints.down('md'));
    const [error, setError] = React.useState('');
    const [success, setSuccess] = React.useState(false);
    const [awaitAata, setAwaitAata] = React.useState<any>('');
    const handleChangeKey = (event: React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement> | undefined) => {
        if (error) {
            setError('');
        }
        event?.target.value && setKey(event?.target.value);
    };
    const handleConfrim = async () => {
        try {
            const arr = key.split('#');
            if (arr.length === 2) {
                let lang = locale === 'zh' ? 'en' : 'zh';

                const { data } = await axiosServices.post(`/web/use_cdkey`, { key_data: arr.at(0), key_sec: arr.at(1), lang });

                if (data.status === 0) {
                    setAwaitAata(data);
                    setSuccess(true);
                } else {
                    setError(data.text);
                }
            } else {
                setError('CD Key 无效');
            }
        } catch (e) {
            console.error(e);
        }
    };

    const handleCloseDialog = async () => {
        if (success) {
            updateProfile();
        }
        setError('');
        setSuccess(false);
        handleClose();
    };

    return (
        <Dialog open={open} sx={{ p: 0 }} onClose={handleCloseDialog}>
            <DialogTitle sx={{ p: 0, pl: 3, fontSize: 21 }}>
                {success ? <FormattedMessage id="cdkey.dialog.success-title" /> : <FormattedMessage id="cdkey.dialog.title" />}
            </DialogTitle>
            {success ? (
                <>
                    <DialogContent sx={{ width: '100%', mt: 2 }}>
                        <Alert severity="success">
                            <FormattedMessage id="cdkey.dialog.success-con" values={{ days: awaitAata.days, quota: awaitAata.quota }} />
                        </Alert>
                    </DialogContent>
                    <DialogActions sx={{ pr: 3 }}>
                        <Button variant="contained" onClick={handleCloseDialog}>
                            <FormattedMessage id="cdkey.dialog.close" />
                        </Button>
                    </DialogActions>
                </>
            ) : (
                <>
                    <DialogContent sx={{ width: '100%' }}>
                        <DialogContentText sx={{ marginTop: 1, fontSize: 18 }}>
                            <FormattedMessage id="cdkey.dialog.content" />
                            <Link
                                component="button"
                                onClick={() => {
                                    window.open('https://x.com/xiaodiqiuyi');
                                }}
                                underline="none"
                            >
                                <FormattedMessage id="cdkey.dialog.link" />
                            </Link>
                            <FormattedMessage id="cdkey.dialog.end" />
                        </DialogContentText>
                        {error && <Alert severity="error">{error}</Alert>}
                        <InputLabel sx={{ marginTop: 1, fontSize: 18 }} shrink htmlFor="bootstrap-input">
                            CD Key
                        </InputLabel>
                        <TextField
                            onChange={handleChangeKey}
                            placeholder="XXXXX-XXXXX-XXXXX-XXXXX#XXXXX"
                            required
                            id="key"
                            name="key"
                            type="text"
                            fullWidth
                            focused
                        />
                    </DialogContent>
                    <DialogActions sx={{ pr: 3 }}>
                        <Button color="error" variant="contained" onClick={handleCloseDialog}>
                            <FormattedMessage id="cdkey.dialog.cancel" />
                        </Button>
                        <Button variant="contained" onClick={handleConfrim}>
                            <FormattedMessage id="cdkey.dialog.confirm" />
                        </Button>
                    </DialogActions>
                </>
            )}
        </Dialog>
    );
};
export default KeyFormDialog;
